import { MULTILANGUAGEGQLSCHEMA } from "./MultiLanguage";

export const BETTINGWEBSITEPAYMENTGATEWAYGQLSCHEMA = `
id
PaymentGatwayName{
    ${MULTILANGUAGEGQLSCHEMA}
}
Logo
`;
